/** The server explains why a planning action was refused (409/422 detail); show that, not a generic line. */
export const planningActionErrorMessage = (error: unknown, fallback: string): string => {
  const response = (error as { response?: { data?: { detail?: unknown; error?: { message?: unknown } } } })?.response;
  const detail = response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  if (detail && typeof detail === 'object' && typeof (detail as { message?: unknown }).message === 'string') {
    return String((detail as { message: string }).message);
  }
  const envelope = response?.data?.error?.message;

  if (typeof envelope === 'string' && envelope.trim()) return envelope.trim();
  if (error instanceof Error && error.message.trim() && !/^Request failed with status/.test(error.message)) {
    return error.message;
  }

  return fallback;
};
